import styled from '@emotion/styled';
import { countryType as country } from '../../../constants/data-types';

export const CardWrapper = styled.div`
  position: relative;
  width: 100%;
  background: ${({ theme: { colors } }) => colors.primaryLight};
  margin-top: 2rem;
  max-width: 800px;
  margin-left: ${({ dir }) => (dir === 'rtl' ? '0' : '-3rem')};
  margin-right: ${({ dir }) => (dir === 'rtl' ? '-3rem' : '0')};
  z-index: 0;
  ${({ theme }) => theme.media.tablet} {
    margin-left: 0rem;
    margin-right: 0rem;
  }
`;

export const RhombusWrapper = styled.div`
  position: absolute;
  top: 0;
  ${({ dir }) => (dir === 'rtl' ? 'right: 0;' : 'left: 0;')}
  border-radius: 20px;
  z-index: 1;
  height: 50px;
  svg {
    transform: ${({ dir }) => (dir === 'rtl' ? 'scaleX(-1)' : 'none')};
  }
  width: ${({ countryType }) =>
    countryType === country.SCOTLAND ? '615px' : '350px'};
  ${({ theme }) => theme.media.mobile} {
    width: ${({ countryType }) =>
      countryType === country.SCOTLAND ? '350px' : '300px'};
    height: ${({ countryType }) =>
      countryType === country.SCOTLAND ? '70px' : '48px'};
  }
`;

export const CardHeader = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 20px;
  width: 100%;
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-top: 3rem;
  ${({ theme }) => theme.media.mobile} {
    padding-top: ${({ countryType }) =>
      countryType === country.SCOTLAND ? '1rem' : ''};
  }
`;

export const LinkContainer = styled.div`
  display: flex;
  justify-content: ${({ dir }) => (dir === 'rtl' ? 'flex-start' : 'flex-end')};
  margin-top: -1rem;
  margin-bottom: 1rem;
  margin: -1rem 2rem 1rem;
  padding-right: ${({ dir }) => (dir === 'rtl' ? '1rem' : '3rem')};
  padding-left: ${({ dir }) => (dir === 'rtl' ? '3rem' : '1rem')};
  width: 100%;
  ${({ theme }) => theme.media.mobile} {
    padding-right: ${({ dir }) => (dir === 'rtl' ? '1rem' : '1rem')};
    padding-left: ${({ dir }) => (dir === 'rtl' ? '1rem' : '1rem')};
  }
`;

export const TextContainer = styled.div`
  position: relative;
  z-index: 10;
  padding-left: ${({ dir }) => (dir === 'rtl' ? '1rem' : '3rem')};
  padding-right: ${({ dir }) => (dir === 'rtl' ? '3rem' : '1rem')};
  padding-top: 0.5rem;
  ${({ theme }) => theme.media.mobile} {
    max-width: ${({ countryType }) =>
      countryType === country.SCOTLAND ? '' : '300px'};
    padding-left: ${({ dir }) => (dir === 'rtl' ? '1rem' : '1.5rem')};
    padding-right: ${({ dir }) => (dir === 'rtl' ? '1.5rem' : '1rem')};
  }
`;

export const CloseButton = styled.button`
  outline: none;
  border: none;
  background: transparent;
  cursor: pointer;
  position: absolute;
  ${({ dir }) => (dir === 'rtl' ? 'left: 0;' : 'right: 0;')}
  top: 0;
  z-index: 10;
  padding: 1rem;
`;
